'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvStop = function AvStop(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 6h12v12H6z' })
  );
};
AvStop = (0, _pure2.default)(AvStop);
AvStop.displayName = 'AvStop';
AvStop.muiName = 'SvgIcon';

exports.default = AvStop;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/av/stop.js
// module id = 1171
// module chunks = 0